import { de } from './de';
import { en } from './en';

export const translations = {
  en: {
    translation: en
  },
  de: {
    translation: de
  }
} as const;